export default __webpack_public_path__ + "eaac5712a98c87cea069d1e34a9731d0.webp";